/**
 * @file_purpose  component created for sidebar of web page
 * @author Swarnali Ghosh
 * @Date_Created 28-02-2024
 * @Date_Modified 01-03-2024
 */

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleSidebar } from '../../redux/slices/changeMenuStateSlice';
import { listGameCategory } from '../../redux/slices/GameCategoriesSlice';
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import Constants from '../../utility/Constants';
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const Sidebar = () => {
  const dispatch = useDispatch();

  const location = useLocation();

  let provider_id = location.state != null ? location.state.provider_id : null;
  let provider_name = location.state != null ? location.state.provider_name : null;

  const menuStatus = useSelector((state) => state.menuState);
  const userDetailState = useSelector((state) => state.userDetailState);
  const gameCategoryState = useSelector((state) => state.gameCategoryState);
  const languageState = useSelector((state) => state.languageState);

  let languageCode = languageState.active_language.language_code;

  const toggleSidebarMenu = () => {
    dispatch(toggleSidebar())
  }

  /**
* @author Swarnali Ghosh
* @Date_Created 04-03-2024
* @Date_Modified 04/03/2023
* @function async
* @functionName loadGameCategoryList
* @functionPurpose this function gets game category list.
* @functionParam {}
* @functionSuccess Success status and message.
* @functionError {Boolean} error is there.
* @functionError {String} message  Description message.
*/

  async function loadGameCategoryList() {

    GeneralService.apiGetCallRequestWithWToken(ApiURL.getGameCategoriesList).then(res => {
      if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {


        dispatch(listGameCategory(res.data))
      }
    }).catch(error => {

    })

  }

  useEffect(() => {
    loadGameCategoryList();
  }, [])

  const checkAvailibility = (linkUrl) => {
    if (userDetailState.user_details) {
      window.location.href = linkUrl
    }
    else {
      toast.info("Please login to access this link.", {
        position: "bottom-right",
      })
    }
  }

  return (
    <>
      <nav className={`sidebar ${menuStatus.active_sidebar ? '' : 'close'}`}>
        <header>
          <div className="image-text">
            <span className="image">
              {/* <img src="https://drive.google.com/uc?export=view&id=1ETZYgPpWbbBtpJnhi42_IR3vOwSOpR4z" alt /> */}
            </span>
            <div className="text logo-text">
            </div>
          </div>
          <i className="fa-solid fa-bars toggle" onClick={() => toggleSidebarMenu()} />
        </header>
        <div className="menu-bar">
          <div className="menu">
            <ul className="menu-links">

              {gameCategoryState.game_category_list?.length > 0 ? gameCategoryState.game_category_list.map((gameCategoryData, index) => (
                <Link to={provider_id != null ? `/games/${gameCategoryData.category_name[languageCode]}/${provider_id}` : `/games/${gameCategoryData.category_name[languageCode]}`} state={{ "category_id": gameCategoryData._id, "category_name": gameCategoryData.category_name, "provider_id": provider_id, "provider_name": provider_name }} key={index} >
                  <li className="nav-link" >
                    {
                      gameCategoryData.category_name[languageCode] == "Slots" ? <img src={gameCategoryData.category_icon} alt="slots_category_icon" /> :
                        gameCategoryData.category_name[languageCode] == "Live Casino" ? <img src={gameCategoryData.category_icon} alt="live_casino_category_icon" /> :
                          gameCategoryData.category_name[languageCode] == "Casino" ? <img src={gameCategoryData.category_icon} alt="casino_category_icon" /> :
                            gameCategoryData.category_name[languageCode] == "Lobby" ? <img src={gameCategoryData.category_icon} alt="lobby_category_icon" /> :
                              gameCategoryData.category_name[languageCode] == "Fishing" ? <img src={gameCategoryData.category_icon} alt="fishing_category_icon" /> :
                                gameCategoryData.category_name[languageCode] == "Sports" ? <img src={gameCategoryData.category_icon} alt="sports_category_icon" /> :
                                  gameCategoryData.category_name[languageCode] == "Virtual Sports" ? <img src={gameCategoryData.category_icon} alt="virtual_sports_category_icon" /> :
                                    gameCategoryData.category_name[languageCode] == "Arcade" ? <img src={gameCategoryData.category_icon} alt="arcade_category_icon" /> :
                                      gameCategoryData.category_name[languageCode] == "Table" ? <img src={gameCategoryData.category_icon} alt="table_category_icon" /> : ""
                    }
                    <span className="text nav-text">{gameCategoryData.category_name[languageCode]}</span>

                  </li>
                </Link>
              ))

                : ""}
            </ul>
          </div>
        </div>
      </nav>

    </>
  )
}

export default Sidebar
